import { useGridApiRef } from "@mui/x-data-grid";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import useAPI from "../../../../../api/hooks/useAPI";
import { controlKeys } from "../../../../../api/queryKeys";
import LoadingIcon from "../../../../../components/LoadingIcon";
import { generateFileName } from "../../../../../hooks/useFileNaming";
import WidgetWrapper from "../../WidgetWrapper";
import ControlsTableWidget from "./ControlsTableWidget";
import { filterFavoriteControls } from "./utils/controlFilters";

const FavoriteControls = () => {
  const { trackEvent, fetchAllControls } = useAPI();
  const gridRef = useGridApiRef();
  const navigate = useNavigate();
  const { data: controls, isLoading: loadingControls } = useQuery({
    queryKey: controlKeys.all,
    queryFn: fetchAllControls,
    select: (data) =>
      data.data.map((control) => ({
        ...control,
        id: control.control_id,
      })),
  });

  const handleTableExport = () => {
    const message =
      "User click on 'Export' button to download the favorite controls table";
    trackEvent(message);
    const csvExportOptions = {
      fileName: generateFileName(`favorite-controls`),
    };
    gridRef?.current?.exportDataAsCsv(csvExportOptions);
  };

  const filteredControls = useMemo(() => {
    if (!controls) return [];
    return filterFavoriteControls(controls);
  }, [controls]);

  const handleViewAll = () => {
    navigate("/posture/controls", {
      state: {
        filters: {
          myFavorites: true,
        },
      },
    });
  };

  return (
    <WidgetWrapper
      title="Favorite Controls"
      onExport={handleTableExport}
      info="Controls you marked as favorites, sorted by severity"
      viewAll={{
        handleViewAll: handleViewAll,
        tooltip: "Go to the full list view",
        newTab: false,
      }}
    >
      {loadingControls ? (
        <LoadingIcon size={12} />
      ) : (
        <ControlsTableWidget
          controls={filteredControls}
          loading={loadingControls}
          refToPass={gridRef}
          columnsToShow={[
            "id",
            "name_for_gap_state",
            "tool",
            "status",
            "severity",
            "affected_entities_count",
            "assignee",
            "ticket",
          ]}
        />
      )}
    </WidgetWrapper>
  );
};

export default FavoriteControls;
